export const ADMINISTRATORS_TRANSLATE = {
    administrators: {
        breadcrumbName: "Administradores",
        messages: {
            create: "Administrador creado exitosamente",
            update: "Administrador actualizado exitosamente",
            delete: "Administrador eliminado exitosamente",
        },
        dialog: {
            delete: {
                title: "Eliminar",
                body: "¿Eliminar administrador \"{{administrator.name}}\"?",
                actions: {
                    primary: "Sí, eliminar",
                    secondary: "Volver",
                }
            }
        },
        fields: {
            name: {
                label: "Nombre",
                placeholder: "Ingrese el nombre aquí",
            },
            email: {
                label: "Correo electrónico",
                placeholder: "Ingrese el correo electrónico aquí"
            },
            password: {
                label: "Contraseña",
                placeholder: "Ingrese la contraseña aquí"
            },
            passwordConfirmation: {
                label: "Confirmación de contraseña",
                placeholder: "Ingrese la misma contraseña aquí"
            },
        }
    }
}
